"use client"
import { Button } from '@open-mercato/ui/primitives/button'

type GlobalErrorProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ reset }: GlobalErrorProps) {
  return (
    <html>
      <body>
        <main style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
          <h1>Something went wrong</h1>
          <p>An unexpected error occurred while rendering this page.</p>
          <Button type="button" variant="outline" onClick={() => reset()}>
            Try again
          </Button>
        </main>
      </body>
    </html>
  )
}
